import { Amplify } from "aws-amplify";
import { SettingsResponse } from "features/settings/definitions";

const LOG = {
  error: (...args: any[]) => console.error("[LOG]", ...args),
  warn: (...args: any[]) => console.warn("[LOG]", ...args),
  info: (...args: any[]) => console.info("[LOG]", ...args),
  debug: (...args: any[]) => console.debug("[LOG]", ...args),
};

export default LOG;

export const configureAmplify = (settings: SettingsResponse) => {
  const auth = prepareAuth(settings);

  Amplify.configure({
    ...(auth ?? {}),
  });

  return true;
};

const prepareAuth = (settings: SettingsResponse) => {
  if (!settings.auth) {
    return undefined;
  }

  const {
    domain,
    identityPoolId,
    region,
    userPoolId,
    userPoolWebClientId,
    state,
  } = settings.auth;

  return {
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId: userPoolWebClientId,
        identityPoolId,
        loginWith: {
          oauth: {
            domain,
            scopes: ["email", "profile", "openid"],
            redirectSignIn: [window.location.origin],
            redirectSignOut: [window.location.origin],
            responseType: "code" as const,
            ...(state ? { state } : {}),
          },
        },
      },
    },
  };
};
